import lazyLoad from 'core/util/lazyLoad';

export const DataExplorerDrawer = lazyLoad(() => import('./DataExplorerDrawer'));
